import { FORM_CONTROL } from "shared/tableStyles";

/** `YYYY-MM-DDTHH:mm` in the browser's local time, the format a datetime-local input takes. */
function localInputValue(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** The input's value as a UTC ISO string for the API, or undefined when blank (the server then uses "now"). */
export function receivedAtIso(value: string): string | undefined {
  if (!value) return undefined;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
}

interface Props {
  id: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

/** "When did they write this?" for a reply logged after the fact. Blank = just now; never in the future. */
export default function ReceivedAtField({ id, value, onChange, disabled }: Props) {
  return (
    <div className="space-y-1">
      <label htmlFor={id} className="block text-xs font-medium text-muted-foreground">Received on (optional)</label>
      <div className="flex flex-wrap items-center gap-2">
        <input id={id} type="datetime-local" value={value} max={localInputValue(new Date())} disabled={disabled}
          onChange={(e) => onChange(e.target.value)} className={`px-3 py-1.5 ${FORM_CONTROL}`} />
        {value && <button type="button" className="text-xs text-muted-foreground underline underline-offset-2" onClick={() => onChange("")}>Use now</button>}
      </div>
      <p className="text-xs text-muted-foreground">Leave blank if you are logging it as it arrives. Set it when the message came in earlier.</p>
    </div>
  );
}
